import React from "react";
import cx from "classnames";
import styles from "./TagList.module.css";
import closeIconSvg from "../../../images/VideospageImages/CloseIcon.svg";
import Image from "next/image";

const TagList = ({ tagTitle, selectedTagName, setFinalTag }) => {
    return(
        <div
            className={cx(
                styles.tagWrapper,
                "d-flex",
                "align-items-center",
                "justify-content-center",
                !selectedTagName && "d-none"
            )}
        >
      <span
          className={cx(
              styles.videoTagStaticText,
              "d-lg-flex",
              "align-items-center",
              "justify-content-center",
              "h-100",
              "d-none"
          )}
      >
          {'تگ‌' + ' ' + tagTitle}
      </span>
            <span
                className={cx(
                    styles.videoTagVerticalLine,
                    "d-lg-flex",
                    "align-items-center",
                    "justify-content-center",
                    "d-none"
                )}
            ></span>
            {selectedTagName && (
                        <div
                            className={cx(
                                styles.tagStyles,
                                "h-100",
                                "d-flex",
                                "align-items-center",
                                "justify-content-center"
                            )}
                        >
                            {/* ======== tag name  */}
                            <span
                                className={cx(
                                    styles.tagName,
                                    "d-flex",
                                    "align-items-center",
                                    "justify-content-center"
                                )}
                            >
                {selectedTagName}
              </span>
                            {/* ======== btn for removing active tag */}
                            <button
                                className={cx(
                                    styles.removeTagBtnStyles,
                                    "d-flex",
                                    "h-100",
                                    "align-items-start",
                                    "justify-content-center"
                                )}
                                onClick={() => setFinalTag("")}
                            >
                                <Image src={closeIconSvg} alt="about digikala group" />
                            </button>
                        </div>
                    )}
        </div>
    )
}

export default TagList